import {useCallback} from 'react';
import {useRemoteData} from '../../common/utils/useRemoteData';
import {getSelfDetails} from '../infrastructure/UserApi';
import {useComercialContext} from '../../comercial/ComercialContext';

export const useSelfDetails = () => {
  const { actingAsCliente } = useComercialContext();
  const actingAsNumCliente = actingAsCliente?.numCliente ?? null;
  // Al cambiar de cliente cambia el callback y useRemoteData vuelve a pedir los datos
  const fetchDetails = useCallback(() => getSelfDetails(actingAsNumCliente), [actingAsNumCliente]);
  const userDetailsRemoteData = useRemoteData({ initialData: null, dataFetchingCallback: fetchDetails });
  return { userDetailsRemoteData, isComercialMode: actingAsNumCliente != null };
};
